import React from "react";
import { Outlet } from "react-router-dom";

import { IBreadcrumbItem, Stack } from "@bps/fluent-ui";
import { routes } from "@libs/routing/routes.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { BreadCrumb } from "@ui-components/navigation/BreadCrumb.tsx";

import {
  SettingsLabels,
  SettingsScreenBreadcrumbKeys
} from "../../shared-components/SettingsLabels.ts";

export const IntegrationBreadcrumbs: React.FC = () => {
  const { routing } = useStores();
  const breadcrumbItems: IBreadcrumbItem[] = [];

  if (routing.match(routes.settings.integrations.physitrack)) {
    breadcrumbItems.push({
      onClick: () =>
        routing.push({
          pathname: routes.settings.integrations.basePath.pattern
        }),
      text: SettingsLabels.integrations,
      key: SettingsScreenBreadcrumbKeys.integrations.toString()
    });

    breadcrumbItems.push({
      text: SettingsLabels.physitrack,
      key: SettingsScreenBreadcrumbKeys.physitrack.toString(),
      isCurrentItem: true
    });
  } else if (routing.match(routes.settings.integrations.xero)) {
    breadcrumbItems.push({
      onClick: () =>
        routing.push({
          pathname: routes.settings.integrations.basePath.pattern
        }),
      text: SettingsLabels.integrations,
      key: SettingsScreenBreadcrumbKeys.integrations.toString()
    });

    breadcrumbItems.push({
      text: SettingsLabels.xero,
      key: SettingsScreenBreadcrumbKeys.xero.toString(),
      isCurrentItem: true
    });
  }

  return (
    <div style={{ paddingBottom: 24 }}>
      <Stack tokens={{ childrenGap: 26 }}>
        <BreadCrumb styles={{ root: { margin: 0 } }} routes={breadcrumbItems} />
        <Outlet />
      </Stack>
    </div>
  );
};
